/* eslint-disable */
export default {
  beforeMount(el, binding, vnode) {
    if (typeof binding.value !== 'function') {
      const compName = vnode?.ctx?.type?.name

      let warn = `[Vue-click-outside:] provided expression must be a function`

      if (compName) {
        warn += ` Found in component '${compName}'`
      }

      console.warn(warn)
    }

    const bubble = binding.modifiers?.bubble

    const handler = (event) => {
      if (bubble || (!el.contains(event.target) && el !== event.target)) {
        binding.value(event)
      }
    }

    el.__vueClickOutside__ = handler

    document.addEventListener('click', handler)
  },

  unmounted(el) {
    document.removeEventListener('click', el.__vueClickOutside__)

    el.__vueClickOutside__ = null
  }
}